<script>
import axios from "axios";
import Swal from "sweetalert2";

export default {
  name: "TabelSemuaKompetensi",

  props: {
    idjadwalPeserta: {
      type: [String, Number],
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      totalSemua: null,
      perKompetensi: [],
    };
  },

  watch: {
    idjadwalPeserta: {
      immediate: true,
      handler(val) {
        if (val) this.fetchData();
      },
    },
  },

  methods: {
    async fetchData() {
      this.loading = true;
      try {
        const response = await axios({
          url: process.env.VUE_APP_BACKEND_URL_VERSION + "report-proctor-peserta/report-validasi-bobot-all-kompetensi",
          method: "get",
          params: { idjadwal_peserta: this.idjadwalPeserta },
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + localStorage.access_token,
          },
        });

        if (response?.data?.meta?.code == 200) {
          this.totalSemua = response.data.data.total_semua_kompetensi;
          this.perKompetensi = response.data.data.per_kompetensi;
          console.log(this.perKompetensi);
        }
      } catch (error) {
        console.log(error);
        Swal.fire({
          icon: "error",
          title: "Peringatan",
          text: "Terjadi kesalahan saat mengambil data validasi kompetensi",
        });
      } finally {
        this.loading = false;
      }
    },

    statusStyle(isValid, keterangan = '') {
      if (isValid === true)  return { backgroundColor: '#d1fae5', color: '#065f46' };
      if (isValid === false && keterangan == 'Pending') return { backgroundColor: '#cccccc', color: '#787878' };
      if (isValid === false) return { backgroundColor: '#fee2e2', color: '#991b1b' };
      return { backgroundColor: '#f3f4f6', color: '#6b7280' };
    },
  },
};
</script>

<template>
  <div>
    <div v-if="loading" class="text-center py-4">
      <i class="fas fa-spinner fa-spin"></i> Loading...
    </div>

    <div v-else class="row">

      <!-- Kiri: Tabel per kompetensi -->
      <div class="col-12 col-lg-6">
        <table class="table table-bordered table-sm mb-0">
          <thead class="table-light">
            <tr>
              <th class="text-center" style="width: 50px;">No</th>
              <th>Nama Kompetensi</th>
              <th class="text-center">Total Skor</th>
              <th class="text-center">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="perKompetensi.length === 0">
              <td colspan="4" class="text-center">Data tidak tersedia</td>
            </tr>
            <tr
              v-else
              v-for="(item, index) in perKompetensi"
              :key="item.idkompetensi"
            >
              <td class="text-center">{{ index + 1 }}</td>
              <td>{{ item.nama_kompetensi }}</td>
              <td class="text-center">
                {{ item.total_skor !== null ? item.total_skor + '%' : '-' }}
              </td>
              <td class="text-center">
                <span
                  class="px-2 py-1 rounded-pill fw-bold"
                  :style="{ ...statusStyle(item.is_valid), fontSize: '0.8rem' }"
                >
                  {{ item.keterangan }}
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Kanan: Total keseluruhan -->
      <div v-if="totalSemua" class="col-12 col-lg-6 d-flex align-items-center justify-content-center">
        <div
          style="
            border: 2px solid #dee2e6;
            border-radius: 16px;
            padding: 40px 48px;
            text-align: center;
            min-width: 220px;
          "
        >
          <div style="font-size: 0.85rem; color: #6c757d; margin-bottom: 12px;">
            Validitas Keseluruhan
          </div>
          <div
            class="px-4 py-2 rounded-pill d-inline-block fw-bold"
            :style="{ ...statusStyle(totalSemua.is_valid, totalSemua.keterangan), fontSize: '1.25rem' }"
          >
            {{ totalSemua.keterangan }}
          </div>
        </div>
      </div>

    </div>
  </div>
</template>
